import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

const AddNotificationModal = ({
  isOpen,
  handleClose,
  handleSaveNotification,
  children,
  handleAPICall,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed z-50 inset-0 overflow-y-auto">
      <div className="flex items-center justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <div className="flex items-center justify-center fixed z-50 inset-0 overflow-y-auto">
          <div className="w-full flex items-center justify-center pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="bg-white rounded-lg shadow-xl max-w-lg mx-auto sm:my-8 p-6">
              <div className="flex justify-between">
                <div></div>
                <span className="cursor-pointer" onClick={handleClose}>
                  <FontAwesomeIcon icon={faClose} />
                </span>
              </div>
              <h2 className="text-lg font-bold text-primaryColor mb-4">
                Add Notifications
              </h2>
              {children}
              <div className="flex items-center justify-center">
                <button
                  className="w-full bg-primaryColor hover:bg-primaryColor text-white font-bold py-2 px-4 rounded-full focus:outline-none focus:shadow-outline"
                  onClick={handleAPICall}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNotificationModal;
